const initialState = () => {
  return {
    productData: []
  }
};

const state = initialState();

const mutations = {
  SET_PRODUCT_DATA(state, payload) {
    state.productData = payload;
  }
};

const actions = {
  getProductData({state, commit}, payload) {
    commit('SET_PRODUCT_DATA', payload);
  }
};

const getters = {
  isSaleable: (state, getters, rootState, rootGetters) => {
    switch (state.productData.product_type) {
      case 'grouped':
        return rootGetters['CatalogGroupedProduct/isSaleable'];
      case 'bundle':
        return rootGetters['CatalogBundleProduct/isSaleable'];
      case 'configurable':
        return rootGetters['CatalogConfigurableProduct/isSaleable'];
      default:
        return state.productData.in_stock;
    }
  },
  totalPrices: (state, getters, rootState, rootGetters) => {
    switch (state.productData.product_type) {
      case 'grouped':
        return rootGetters['CatalogGroupedProduct/totalPrices'];
      case 'bundle':
        return rootGetters['CatalogBundleProduct/totalPrices'];
      case 'configurable':
        return rootGetters['CatalogConfigurableProduct/totalPrices'];
      default:
        return {
          priceInclTax: state.productData.price_incl_tax,
          priceExclTax: state.productData.price_excl_tax,
          totalPriceInclTax: state.productData.final_price_incl_tax,
          totalPriceExclTax: state.productData.final_price_excl_tax
        };
    }
  }
};

const CatalogProduct = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

export default CatalogProduct;
